module.exports = __webpack_public_path__ + "media/images/logo/logo_mini_color_2x-4b06861ad80cf56b5c211c9bd4604c54.png";